const wordList6 = [
  {pl: "śniadanie", de: "das Frühstück"},
  {pl: "obiad", de: "das Mittagessen"},
  {pl: "kolacja", de: "das Abendessen"},
  {pl: "przekąska", de: "der Snack"},
  {pl: "burger", de: "der Burger"},
  {pl: "burger wegetariański", de: "der Veggie-Burger"},
  {pl: "kebab", de: "der Doner"},
  {pl: "potrawa jednogarnkowa", de: "der Eintopf"},
  {pl: "fast food", de: "das Fast Food"},
  {pl: "kotlet mielony, pulpet", de: "die Frikadelle"},
  {pl: "gulasz", de: "das Gulasch"},
  {pl: "kotlet", de: "das Kotelett"},
  {pl: "ciasto", de: "der Kuchen"},
  {pl: "lazania", de: "die Lasagne"},
  {pl: "ulubione jedzenie", de: "das Lieblingsessen"},
  {pl: "muffin, babeczka", de: "der Muffin"},
  {pl: "muffin czekoladowy", de: "der Schoko-Muffin"},
  {pl: "ciastko", de: "das Plätzchen"},
  {pl: "frytki", de: "die Pommes"},
  {pl: "puree", de: "das Puree"},
  {pl: "risotto", de: "das Risotto"},
  {pl: "jajecznica", de: "das Rührei"},
  {pl: "kanapka", de: "der Sandwich"},
  {pl: "czekolada", de: "die Schokolade"},
  {pl: "sok jabłkowy zmieszany z wodą mineralną", de: "die Apfelschorle"},
  {pl: "kawa", de: "der Kaffee"},
  {pl: "kakao", de: "der Kakao"},
  {pl: "lemoniada", de: "die Limonade"},
  {pl: "mleko", de: "die Milch"},
  {pl: "woda mineralna", de: "das Mineralwasser"},
  {pl: "sok", de: "der Saft"},
  {pl: "sok jabłkowy", de: "der Apfelsaft"},
  {pl: "sok pomarańczowy", de: "der Orangensaft"},
  {pl: "herbata", de: "der Tee"},
  {pl: "woda", de: "das Wasser"},
  {pl: "jajko", de: "das Ei"},
  {pl: "tłuszcz", de: "das Fett"},
  {pl: "masło", de: "die Butter"},
  {pl: "olej", de: "das Öl"},
  {pl: "ryba", de: "der Fisch"},
  {pl: "tuńczyk", de: "der Thunfisch"},
  {pl: "mięso", de: "das Fleisch"},
  {pl: "szynka", de: "der Schinken"},
  {pl: "kurczak", de: "das Hähnchen"},
  {pl: "warzywa", de: "das Gemüse"},
  {pl: "ogórek", de: "die Gurke"},
  {pl: "ziemniak", de: "die Kartoffel"},
  {pl: "papryka", de: "die Paprika"},
  {pl: "sałatka, sałata", de: "der Salat"},
  {pl: "zielona sałata", de: "der grüne Salat"},
  {pl: "szpinak", de: "der Spinat"},
  {pl: "pomidor", de: "die Tomate"},
  {pl: "produkt zbożowy", de: "das Getreideprodukt"},
  {pl: "chleb", de: "das Brot"},
  {pl: "bułka", de: "das Brötchen"},
  {pl: "płatki kukurydziane", de: "die Cornflakes"},
  {pl: "kasza kuskus", de: "der Couscous"},
  {pl: "muesli", de: "das Müsli"},
  {pl: "makaron", de: "die Nudel"},
  {pl: "ryż", de: "der Reis"},
  {pl: "spaghetti", de: "die Spaghetti"},
  {pl: "nabiał", de: "das Milchprodukt"},
  {pl: "jogurt", de: "der Joghurt"},
  {pl: "ser", de: "der Käse"},
  {pl: "twaróg", de: "der Quark"},
  {pl: "owoce", de: "das Obst"},
  {pl: "jabłko", de: "der Apfel"},
  {pl: "banan", de: "die Banane"},
  {pl: "mango", de: "die Mango"},
  {pl: "prosty", de: "einfach"},
  {pl: "prościej", de: "einfacher"},
  {pl: "najprościej", de: "am einfachsten"},
  {pl: "chętnie", de: "gern"},
  {pl: "chętniej", de: "lieber"},
  {pl: "najchętniej", de: "am liebsten"},
  {pl: "dobry", de: "gut"},
  {pl: "lepiej", de: "besser"},
  {pl: "najlepiej", de: "am besten"},
  {pl: "smaczny", de: "lecker"},
  {pl: "szybko", de: "schnell"},
  {pl: "szybciej", de: "schneller"},
  {pl: "najszybciej", de: "am schnellsten"},
  {pl: "jeść", de: "essen"},
  {pl: "Jestem głodny", de: "Ich habe Hunger"},
  {pl: "Nie jestem głodny", de: "Ich habe keinen Hunger"},
  {pl: "Jestem głodny", de: "Ich bin hungrig"},
  {pl: "Nie jestem głodny", de: "Ich bin nicht hungrig"},
  {pl: "Jestem najedzony", de: "Ich bin satt"},
  {pl: "pić", de: "trinken"},
  {pl: "Chce mi się pić", de: "Ich habe Durst"},
  {pl: "Nie chce mi się pić", de: "Ich habe keinen Durst"},
  {pl: "Chce mi się pić", de: "Ich bin durstig"},
  {pl: "Nie chce mi się pić", de: "Ich bin nicht durstig"},
  {pl: "eurocent", de: "der Cent"},
  {pl: "euro", de: "der Euro"},
  {pl: "kosztować", de: "kosten"},
  {pl: "ile kosztuje", de: "Was kostet"},
  {pl: "cena", de: "der Preis"},
  {pl: "Smacznego", de: "Guten Appetit"},
  {pl: "stołówka, mensa", de: "die Mensa"},
  {pl: "brać", de: "nehmen"},
  {pl: "Wezmę lasagne", de: "Ich nehme die Lasagne"},
  {pl: "chcieć (tryb przypuszczający)", de: "möchte"},
  {pl: "Chciałbym herbatę", de: "Ich möchte gern Tee"},
  {pl: "restauracja", de: "das Restaurant"},
  {pl: "zawsze, ciągle", de: "immer"},
  {pl: "często", de: "oft"},
  {pl: "czasami", de: "manchmal"},
  {pl: "rzadko", de: "selten"},
  {pl: "nigdy", de: "nie"},
  {pl: "szyncel sojowy", de: "das Soja-Schnitzel"},
  {pl: "zupa", de: "die Suppe"},
  {pl: "sos pomidorowy", de: "die Tomatensauce"},
  {pl: "tortilla, naleśnik", de: "die Tortilla"},
  {pl: "kiełbaska", de: "das Wurstchen"},
  {pl: "smakować", de: "schmecken"},
  {pl: "Jak smakuje", de: "Wie schmeckt's"},
  {pl: "menu", de: "die Speisekarte"},
  {pl: "Co podać", de: "Was darf es sein"},
  {pl: "schnitzel", de: "das Schnitzel"}
];

export default wordList6;